module.exports = __webpack_public_path__ + "static/img/No3.c0e5d151.svg";